import styled from "styled-components";

const ToggleButtonWrapper = styled.div`
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // flex-direction: column;
    // padding-bottom: 2%;
`;

const AddRemoveBtnWrapper = styled.button`
    border-radius: 50%;
    border: 1px solid;
    background-color: var(--blue-green);
`;

export { ToggleButtonWrapper, AddRemoveBtnWrapper };
